import { SERVER_URL } from "../constants/constants.js";
import { customFetch } from "../components/common/fetchWrapper";

export const pagetypeService = {
  getList,
  getPageTypeTree,
  createPagetype,
  createPageGroup,
  updatePagetypeList,
  getUngroupedPagetypeId,
  getUnclassifiedPagetypeId,
  getPageTypeInspection,
  getGroupList,
  getPageTypesForGroup,
  addPageTypeForGroup,
  removePageTypeForGroup,
};

async function getList(org_id) {
  const url = SERVER_URL + "/org/" + org_id + "/pagetype";
  const list = await customFetch("GET", url, null, null);
  return list;
}

async function getPageTypeTree(org_id) {
  const url = SERVER_URL + "/org/" + org_id + "/pagetype/tree";
  const tree = await customFetch("GET", url, null, null);
  return tree;
}

async function getGroupList(org_id) {
  const url = SERVER_URL + "/org/" + org_id + "/pagegroup";
  const list = await customFetch("GET", url, null, null);
  return list;
}

async function getPageTypesForGroup(org_id, group_id) {
  const url =
    SERVER_URL + "/org/" + org_id + "/pagegroup/" + group_id + "/types";
  const list = await customFetch("GET", url, null, null);
  return list;
}

async function addPageTypeForGroup(org_id, group_id, type_id) {
  const param = { page_type_id: type_id };
  const url = SERVER_URL + "/org/" + org_id + "/pagegroup/" + group_id;
  const list = await customFetch("POST", url, null, JSON.stringify(param));
  return list;
}

async function removePageTypeForGroup(org_id, group_id, type_id) {
  const param = { page_type_id: type_id };
  const url = SERVER_URL + "/org/" + org_id + "/pagegroup/" + group_id;
  const list = await customFetch("DELETE", url, null, JSON.stringify(param));
  return list;
}

async function createPagetype(page_type) {
  const url = SERVER_URL + "/org/" + page_type.org_id + "/pagetype";
  const pagetype = await customFetch(
    "POST",
    url,
    null,
    JSON.stringify(page_type)
  );
  return pagetype;
}

async function createPageGroup(page_type) {
  const url = SERVER_URL + "/org/" + page_type.org_id + "/pagegroup";
  const pagegroup = await customFetch(
    "POST",
    url,
    null,
    JSON.stringify(page_type)
  );
  return pagegroup;
}

async function updatePagetypeList(list, org_id) {
  const url = SERVER_URL + "/org/" + org_id + "/pagetype";
  const retval = await customFetch("PUT", url, null, JSON.stringify(list));
  return retval;
}

async function getUngroupedPagetypeId(org_id) {
  const url = SERVER_URL + "/org/" + org_id + "/ungrouped_pagetype_id";
  const retval = await customFetch("GET", url, null, null);
  return retval;
}

async function getUnclassifiedPagetypeId(org_id) {
  const url = SERVER_URL + "/org/" + org_id + "/unclassified_pagetype_id";
  const retval = await customFetch("GET", url, null, null);
  return retval;
}

async function getPageTypeInspection(org_id) {
  const url = SERVER_URL + "/org/" + org_id + "/pagetype/inspect";
  const list = await customFetch("GET", url, null, null);
  return list;
}
